<div class="modal-overlay" *ngIf="isVisible" (click)="onClose()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="modal-header">
      <div class="header-content">
        <h2 class="modal-title">Select a reason for cancelations<span class="required">*</span></h2>
        <button class="close-button" (click)="onClose()">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 5L5 15M5 5L15 15" stroke="#101223" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Body -->
    <div class="modal-body">
      <div class="reasons-container">
        <div 
          class="reason-item" 
          *ngFor="let reason of cancellationReasons; trackBy: trackByIndex"
          [class.selected]="selectedReason === reason"
          (click)="onReasonSelect(reason)"
        >
          <div class="reason-content">
            <div class="reason-text">
              <span class="reason-label" [class.other-label]="reason === 'Other'">{{ reason }}</span>
            </div>
            <div class="radio-container">
              <div class="radio-button" [class.checked]="selectedReason === reason">
                <div class="radio-inner" *ngIf="selectedReason === reason"></div>
              </div>
            </div>
          </div>
          
          <!-- Text area for "Other" reason -->
          <div class="other-reason-container" *ngIf="reason === 'Other' && isOtherSelected">
            <textarea 
              class="other-reason-input"
              placeholder="Type your reason here"
              [(ngModel)]="otherReason"
              rows="4"
              [class.error]="isCharacterLimitExceeded || isOtherReasonEmpty"
            ></textarea>
            <div class="validation-message" *ngIf="isOtherReasonEmpty">
              Please provide a reason for cancellation
            </div>
            <div class="character-counter" *ngIf="isCharacterLimitExceeded">
              You've exceeded the limit by {{ exceededCharacters }} characters!
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <div class="button-container">
        <button 
          class="btn btn-primary btn-medium" 
          [class.disabled]="isSubmitDisabled"
          [disabled]="isSubmitDisabled"
          (click)="onSubmit()"
        >
          Continue
        </button>
      </div>
    </div>
  </div>
</div>
